module.exports = {
    APLAZADO_TAE: 'aplazado_tae',
    APLAZADO_TIN: 'aplazado_tin',
    CALCULATION_TYPE_FIXED_FEE: 0,
    CALCULATION_TYPE_VARIABLE_FEE: 1,
    LOW_FEE_ERROR: 409,
};